import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const GAStyrvardeMeny: IRutinInfo[] = [
  rutinInfos.optGravlistor,
  rutinInfos.rtnKundkategori,
  rutinInfos.rtnFakturalayout,
];

export default GAStyrvardeMeny;
